import React, { useState, useContext, useEffect } from "react";
import "./RoCard.scss";
import RoHistory from "./RoHistory";
import HistoryIcon from "../../assets/icons/HistoryIcon";
import CompleteRoIcon from "../../assets/icons/CompleteRoIcon";
import dashboardApi from "../../services/dashboardApi";
import { toast } from "react-toastify";
import ConfirmationModal from "../../components/confirmationModal/ConfirmationModal";
import { ROStatusEnum } from "../../enum/enums";
import { getRoStatusName } from "../../utils/common";


// RO CONFIRM
import { AuthContext } from "../../context/AuthContext";

const RoCard = ({task,reloadData}) => {
const isoDate = task.createdAt;
// RO CONFIRM
const { isROConfirmationModalVisible, setIsROConfirmationModalVisible, isROCompletionConfirmed,setCompletedTaskId } = useContext(AuthContext);
const date = new Date(isoDate);
const formattedDate = date.toLocaleDateString('en-GB', {
  day: 'numeric',
  month: 'long',
  year: 'numeric'
});
const apiBaseUrl = process.env.REACT_APP_API_URL;
const RepairOrderStatusToolTip = ({ status }) => {
  let statusText;

  switch (status) {
    case ROStatusEnum.COMPLETED:
      statusText = 'Complete Repair Order';
      break;
    case ROStatusEnum.IN_PROGRESS:
      statusText = 'In-Progress Repair Order';
      break;
    case ROStatusEnum.UNASSIGNED:
      statusText = 'Unassigned Repair Order';
      break;
    case ROStatusEnum.NOT_STARTED:
      statusText = 'Not Started Repair Order';
      break;
    case ROStatusEnum.DELAYED:
        statusText = 'Delayed Repair Order';
        break;
    case ROStatusEnum.FINAL_MINUTES:
          statusText = 'Final Minutes Repair Order';
          break;
    default:
      statusText = 'Unassigned Repair Order';
  }

  return <span>{statusText}</span>;
};

const [ShowRoDetail, setShowRoDetail] = useState(false);
// RO CONFIRM
//const [isModalVisible, setIsModalVisible] = useState(false);

  const openRoDetail = () => {
    setShowRoDetail(!ShowRoDetail);
  };  
  const onCompleteClick = async () => {  
    // RO CONFIRM
    //setIsModalVisible(true); 
    setCompletedTaskId(task?.repairOrderId);
    setIsROConfirmationModalVisible(true); 
  };

  return (
    <div className="card-container">
      <div className="card-top">
        <div className="top-left">
          <div className="date">{formattedDate}</div>
          <div className="task-id">{task.roNumber}</div>
        </div>
        <div className="ro-status">
        {
          task.stageDetails.map((stage) => (
            <div className={`status toolTip ${stage.taskStatus}`}>
              <div className="stage-img" 
              style={{
                maskImage: `url(${apiBaseUrl + stage.stageImagePath})`,
              }}
              ></div>
              <span>{stage.roStageName+ "  (" + getRoStatusName(stage.taskStatus) + ")"}</span>
            </div>
          ))
        }          
        </div>
        <div className="top-right">
          <span>
            <svg width="11.442" height="11.442" viewBox="0 0 11.442 11.442">
              <g
                id="Icon_feather-clock"
                data-name="Icon feather-clock"
                transform="translate(-2.5 -2.5)"
              >
                <path
                  id="Path_2526"
                  data-name="Path 2526"
                  d="M13.442,8.221A5.221,5.221,0,1,1,8.221,3,5.221,5.221,0,0,1,13.442,8.221Z"
                  fill="none"
                  stroke="#a4a0a0"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1"
                />
                <path
                  id="Path_2527"
                  data-name="Path 2527"
                  d="M18,9v3.133l2.088,1.044"
                  transform="translate(-9.779 -3.912)"
                  fill="none"
                  stroke="#a4a0a0"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1"
                />
              </g>
            </svg>
          </span>
          <div className="actual-time">{task.ROHours}</div>
          <span>
            <svg width="6.119" height="6.533" viewBox="0 0 6.119 6.533">
              <g
                id="Icon_feather-arrow-right"
                data-name="Icon feather-arrow-right"
                transform="translate(-7 -6.793)"
              >
                <path
                  id="Path_2528"
                  data-name="Path 2528"
                  d="M7.5,18h5.119"
                  transform="translate(0 -7.94)"
                  fill="none"
                  stroke="#a4a0a0"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1"
                />
                <path
                  id="Path_2529"
                  data-name="Path 2529"
                  d="M18,7.5l2.56,2.56L18,12.619"
                  transform="translate(-7.94)"
                  fill="none"
                  stroke="#a4a0a0"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1"
                />
              </g>
            </svg>
          </span>
          <div className="spend-time">{Math.round(task.utilizedTaskDuration)}</div>
          <span>
            <svg width="6.119" height="6.533" viewBox="0 0 6.119 6.533">
              <g
                id="Icon_feather-arrow-right"
                data-name="Icon feather-arrow-right"
                transform="translate(-7 -6.793)"
              >
                <path
                  id="Path_2528"
                  data-name="Path 2528"
                  d="M7.5,18h5.119"
                  transform="translate(0 -7.94)"
                  fill="none"
                  stroke="#a4a0a0"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1"
                />
                <path
                  id="Path_2529"
                  data-name="Path 2529"
                  d="M18,7.5l2.56,2.56L18,12.619"
                  transform="translate(-7.94)"
                  fill="none"
                  stroke="#a4a0a0"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1"
                />
              </g>
            </svg>
          </span>
          <div className="remaining-time">{task.remainingROHours}</div>
        </div>
      </div>
      <div className="card-bottom">
        <div className="bottom-left">
          <div className="task-desc">{task.customerName}</div>
        </div>
        <div className="bottom-right">
          <div className={`${task.partsReceivedPercentage > 0 ? "yes" : "no"} parts-status`}></div>
          <button className={`completeRO toolTip ${task.roItemStatus}`} onClick={onCompleteClick}>
            <div className="icon">
              <CompleteRoIcon/>
            </div>
            <RepairOrderStatusToolTip status={task.roItemStatus} />
          </button>
          <button className="history" onClick={openRoDetail}>
            <HistoryIcon/>
          </button>
        </div>
      </div>
      {ShowRoDetail  && (
        <RoHistory repairOrderId={task.repairOrderId}/>
      )}
      {/* <ConfirmationModal
        show={isModalVisible}
        title="Change Status"
        message="Are you sure you want to change the status of this repair order to Complete?"
        onConfirm={handleConfirmDelete}
        onCancel={closeModal}
        confirmText="Yes, Change"
        cancelText="No, Cancel"
      /> */}
    </div>
  );
};

export default RoCard;